"use client"

import Image from "next/image";
import Link from "next/link";
import { motion } from "motion/react";

type PortfolioCardsItems = {
    icon: boolean;
    image:  string;
    title: string;
    description: string;
    link?: string;
}

type PortfolioCardsProps = {
  items: PortfolioCardsItems[];
  colorMode: boolean;
  uptitle?: string;
  title?: string;
  backgroundColor?: string;
}

export const PortfolioCards = ({ items, colorMode, uptitle, title, backgroundColor = "#FFFFFF"}: PortfolioCardsProps) => {

    const containerVariants = {
        hidden: {},
        show: {
          transition: {
            staggerChildren: 0.15,
          },
        },
      };
    
      const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        show: { opacity: 1, y: 0, transition: { ease: "easeOut" as const, duration: 1 } },
      };
    

      return (
        <section className="py-44" style={{ backgroundColor }}>
          <div className="mx-auto w-full max-w-7xl px-6">
            {/* Title */}
            {(uptitle || title) && (
              <div className="flex flex-col items-center gap-2 mb-4 md:mb-11">
                {uptitle && <p className="text-center text-muted-foreground">{uptitle}</p>}
                {title && <h2 className="text-center text-3xl lg:text-2xl">{title}</h2>}
              </div>
            )}
            <motion.div
              className="grid grid-cols-1 gap-x-4 gap-y-3 my-6 lg:gap-y-4 lg:grid-cols-3 sm:mt-16 sm:mb-14 text-left justify-start"
              variants={containerVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.25 }}
            >
          {items.map((item) =>
            item.link && item.link !== "#" ? (
              <Link key={item.title} href={item.link} target='_blank' className="cursor-pointer">
                <motion.div
                  variants={itemVariants}
                  className="border-solid border-2 border-gray-200 hover:border-gray-400 rounded-lg text-left justify-start pt-10 pb-6 px-7"
                >
                  <Image
                    src={item.image}
                    alt={"Picture"}
                    width={item.icon ? 53 : 55}
                    height={item.icon ? 53 : 55}
                    className={item.icon ? "text-black flex-none rounded-2xl bg-gray-50 p-4 filter grayscale-[100%]" : "text-black flex-none rounded-2xl bg-gray-50 p-3 filter grayscale-[100%]"}
                  />
                  <div className="mt-5">
                    <h4 className='font-normal tracking-normal text-xl sm:text-base text-black mt-1'>
                      {item.title}
                    </h4>
                    <p className={'leading-6 text-sm text-gray-500 mt-2'}>
                      {item.description}
                    </p>
                  </div>
                </motion.div>
              </Link>
            ) : (
              <motion.div
                key={item.title}
                variants={itemVariants}
                className={`border-solid border-2 border-gray-200 rounded-lg text-left justify-start ${item.icon ? "pt-10 pb-6 px-7" : "py-7"}`}
              >
                <Image
                  src={item.image}
                  alt={"Picture"}
                  width={item.icon ? 53 : 53}
                  height={item.icon ? 53 : 53}
                  className={item.icon ? "text-black flex-none rounded-2xl bg-gray-50 p-4" : `${colorMode ? "filter grayscale-[30%]" : "filter grayscale-[100%]"} ml-4`}
                />
                <div className={`${item.icon ? 'mt-5' : 'mt-3 px-7'}`}>
                  <h4 className='font-normal tracking-normal text-xl sm:text-base text-black mt-1'>
                    {item.title}
                  </h4>
                  <p className={'leading-6 text-sm text-gray-600 mt-2'}>
                    {item.description}
                  </p>
                </div>
              </motion.div>
            )
          )}
            </motion.div>
          </div>
        </section>
      )
}

